<div class="border bg-white rounded-sm">

  <input #input
         class="form-control bg-transparent border-0 pr-1"
         type="text"
         [attr.aria-label]="placeholder"
         [class.loading]="loading"
         [placeholder]="placeholder"
         [(ngModel)]="query"
         (ngModelChange)="queryChange.emit(query)">

  @if (input.value.length > 0) {
    <button class="search-button btn py-0 pl-0"
            type="button"
            (click)="clear(); input.focus()">
      <span class="d-none">{{'base.clear_input' | transloco}}</span>
    </button>
  }

</div>
